import { useFormikContext } from "formik";
import Barcode from "react-barcode";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Table } from "../../Table";
import { CreateOfferData } from "../../../types/offers";
import { useMemo } from "react";
import { format } from "date-fns";
import { map } from "lodash";
import { formatPrice } from "../../../utils/helpers/Format";

export function Review() {
  const formik = useFormikContext<CreateOfferData>();

  const formatDate = (date: Date | null): Date | String | null => {
    if (!date) {
      return date;
    }

    return format(date, "dd/MM/yyyy HH:mm");
  };

  const offerType = useMemo(() => {
    switch (formik.values.type) {
      case "one_to_one":
        return "One to one";
      case "personalized":
        return "Personalizada";
      case "price_two":
        return "Preço dois";
      default:
        return "Personalizada";
    }
  }, [formik.values.type]);

  return (
    <Stack spacing={4}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography color="primary">Resumo</Typography>
      </Stack>
      <Typography>Oferta: {offerType}</Typography>
      <Typography>Nome: {formik.values.name}</Typography>
      {formik.values.type === "personalized" && (
        <Typography>Audiência: {formik.values.insight?.nameList}</Typography>
      )}
      <Typography>
        <>Data de início: {formatDate(formik.values.startDate)}</>
      </Typography>
      <Typography>
        <>Data de término: {formatDate(formik.values.endDate)}</>
      </Typography>
      <Typography>
        Lojas:{" "}
        {map(formik.values.stores, (store) => store.nome_loja).join(", ")}
      </Typography>
      <Typography>Produtos</Typography>
      <Table
        style={{ width: "100%" }}
        toolbar={false}
        data={formik.values.products}
        columns={[
          {
            title: "ID",
            field: "id",
          },
          {
            title: "EAN",
            field: "ean",
            render: (row) => (
              <Barcode
                value={row.ean}
                displayValue
                format="EAN13"
                width={1}
                height={15}
                textMargin={0}
                fontSize={10}
              />
            ),
          },
          {
            title: "Nome",
            field: "name",
            render: (row) => <Typography noWrap>{row.name}</Typography>,
          },
          {
            title: "Preço",
            field: "price",
            render: (row) => formatPrice(row.price),
          },
          {
            title: "Porcentagem",
            field: "percentage",
            render: (row) => `${row.percentage}%`,
          },
          {
            title: "Preço dois",
            field: "discount_price",
            render: (row) => formatPrice(row.discount_price),
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          pageSize: 4,
          selectionProps: () => ({ color: "primary" }),
        }}
      />
    </Stack>
  );
}
